// extracted by mini-css-extract-plugin
module.exports = {"container":"DirectionsPanel_container__CzG-o","form":"DirectionsPanel_form__2WpOT","results":"DirectionsPanel_results__1CLEI"};